import { FC } from 'react';
import { useStyles } from './styles';
import { ReactComponent as Logo } from 'assets/logoDark.svg';
import { ReactComponent as Success } from 'assets/success.svg';
import { ReactComponent as Fail } from 'assets/failed.svg';
import { Button, Paper } from '@material-ui/core';

const StatusPage: FC<any> = ({ status, heading, detail, onEventClick }) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.topBar}>
        <Logo style={{ marginLeft: '40px', width: '140px', height: '52px' }} />
      </div>
      <div className={classes.container}>
        <Paper className={classes.paper} elevation={3}>
          {/* <Success /> */}
          {status === 'fail' ? <Fail /> : <Success />}
          <p className={classes.heading}>{heading}</p>
          <p className={classes.detail}>{detail}</p>
          <Button className={classes.button} variant='contained' color='primary' onClick={onEventClick}>
            Continue
          </Button>
        </Paper>
      </div>
    </>
  );
};

export default StatusPage;
